import { render, staticRenderFns } from "./Mint.vue?vue&type=template&id=0d8018bc&scoped=true&"
import script from "./Mint.vue?vue&type=script&lang=ts&"
export * from "./Mint.vue?vue&type=script&lang=ts&"
import style0 from "./Mint.vue?vue&type=style&index=0&id=0d8018bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8018bc",
  null
  
)

export default component.exports